// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    RoleType,
    SiteLongResponse,
    SiteModelResponse,
    SiteModels,
    SiteSearchModelResponse,
    SiteSearchRequestModel,
    SiteSharedContactModels,
    UpsearchModelSiteSiteUpsearchModel,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class SiteV3Api extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @summary Get existing Contacts by Tenant and Parent identifiers.
     * @param parentId Parent identifier
     */
    public async siteContactGetByTenantId (parentId: number): Promise<AxiosResponse<SiteSharedContactModels>> {
        const _url_ = '/site/v3/SiteContact/{parentId}'
            .replace('{' + 'parentId' + '}', encodeURIComponent(String(parentId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'parentId' is not null or undefined
        if (parentId === null || parentId === undefined) {
            throw new Error('Required parameter parentId was null or undefined when calling siteContactGetByTenantId.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SiteSharedContactModels>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteSharedContactModels");
        }
        return response;
    }
    /**
     * 
     * @summary Get a Site
     * @param siteId Site identifier
     * @param roleType Role Type
     */
    public async siteGetByTenantId (siteId: number, roleType: enums.RoleType): Promise<AxiosResponse<SiteModelResponse>> {
        const _url_ = '/site/v3/Site/{siteId}/{roleType}'
            .replace('{' + 'siteId' + '}', encodeURIComponent(String(siteId)))
            .replace('{' + 'roleType' + '}', encodeURIComponent(String(roleType)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'siteId' is not null or undefined
        if (siteId === null || siteId === undefined) {
            throw new Error('Required parameter siteId was null or undefined when calling siteGetByTenantId.');
        }

        // verify required parameter 'roleType' is not null or undefined
        if (roleType === null || roleType === undefined) {
            throw new Error('Required parameter roleType was null or undefined when calling siteGetByTenantId.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SiteModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteModelResponse");
        }
        return response;
    }
    /**
     * 
     * @summary Get a list of Sites by IDs
     * @param requestBody List of Site identifiers
     */
    public async siteListByTenantId (requestBody: Array<number>): Promise<AxiosResponse<SiteModels>> {
        const _url_ = '/site/v3/SiteList';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'requestBody' is not null or undefined
        if (requestBody === null || requestBody === undefined) {
            throw new Error('Required parameter requestBody was null or undefined when calling siteListByTenantId.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(requestBody, "Array<number>"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SiteModels>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteModels");
        }
        return response;
    }
    /**
     * 
     * @summary Search for Sites that match supplied criteria.  Note: External Ids are deprecated, use Global Ids.
     * @param siteSearchRequestModel Search criteria
     */
    public async siteSearchByTenantId (siteSearchRequestModel: SiteSearchRequestModel): Promise<AxiosResponse<SiteSearchModelResponse>> {
        const _url_ = '/site/v3/SiteSearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'siteSearchRequestModel' is not null or undefined
        if (siteSearchRequestModel === null || siteSearchRequestModel === undefined) {
            throw new Error('Required parameter siteSearchRequestModel was null or undefined when calling siteSearchByTenantId.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(siteSearchRequestModel, "SiteSearchRequestModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SiteSearchModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteSearchModelResponse");
        }
        return response;
    }
    /**
     * 
     * @summary Search for Sites that match supplied criteria.  Note: External Ids are deprecated, use Global Ids.
     * @param upsearchModelSiteSiteUpsearchModel Upsearch criteria
     */
    public async siteUpsearchByTenantId (upsearchModelSiteSiteUpsearchModel: UpsearchModelSiteSiteUpsearchModel): Promise<AxiosResponse<SiteLongResponse>> {
        const _url_ = '/site/v3/SiteUpsearch';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'upsearchModelSiteSiteUpsearchModel' is not null or undefined
        if (upsearchModelSiteSiteUpsearchModel === null || upsearchModelSiteSiteUpsearchModel === undefined) {
            throw new Error('Required parameter upsearchModelSiteSiteUpsearchModel was null or undefined when calling siteUpsearchByTenantId.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(upsearchModelSiteSiteUpsearchModel, "UpsearchModelSiteSiteUpsearchModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SiteLongResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteLongResponse");
        }
        return response;
    }
    /**
     * 
     * @summary Get a list of Sites associated with a Tenant and Prescriber identifiers.
     * @param prescriberId Prescriber identifier
     */
    public async sitesByPrescriberGetByTenantId1 (prescriberId: number): Promise<AxiosResponse<SiteModels>> {
        const _url_ = '/site/v3/SitesByPrescriber/{prescriberId}'
            .replace('{' + 'prescriberId' + '}', encodeURIComponent(String(prescriberId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'prescriberId' is not null or undefined
        if (prescriberId === null || prescriberId === undefined) {
            throw new Error('Required parameter prescriberId was null or undefined when calling sitesByPrescriberGetByTenantId1.');
        }


        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<SiteModels>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "SiteModels");
        }
        return response;
    }
}
